// Practice Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DateUtil from '../../../lib/dateutil.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'

class TaskSubItem extends Component {
  static get propTypes () {
    return {
      item: PropTypes.object,
      onCompleteSubtask: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      item: null,
      onCompleteSubtask: null
    }
  }

  _onCompleteSubtask (bCompleted) {
    const { onCompleteSubtask } = this.props
    if (onCompleteSubtask) {
      onCompleteSubtask(bCompleted)
    }
  }

  render () {
    const { item } = this.props

    return (
      <div className='subtaskitem'>
        <div className='subtaskinfo subtaskinfo-logo'>
          <IconButton icon='tasks' iconSize='26' type='transparent' canHover />
        </div>

        <div className='subtask-title'>
          {item.title}
        </div>

        <div className='subtask-description'>
          <div
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
        </div>

        <div className='task-project-name' />

        <div className='task-client-name' />

        <div className='task-due-date'>
          <div className='info date'>
            {item.dueDate ? DateUtil.getDisplayDate(item.dueDate) : '-'}
          </div>
        </div>

        <div className='task-assignee' />

        <div className='task-project-hour' />

        <div className='task-budget-hour' />

        <div className='task-time' />

        <div className='task-priority' />

        <div
          className='subtask-status'
        >
          <div className='data'>
            {!item.completed ? (
              <IconButton
                icon='done'
                type='disabled'
                canHover
                onClick={this._onCompleteSubtask.bind(this, true)}
              />
            ) : (
              <IconButton
                icon='done'
                type='success'
                canHover
                onClick={this._onCompleteSubtask.bind(this, false)}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default TaskSubItem
